"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var ProficiencyProgressCircle_1 = __importDefault(require("../../ProficiencyProgressCircle"));
var Button_1 = __importDefault(require("../../Button"));
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
        },
        filterActive: {
            color: theme.palette.primary.main,
            fontWeight: 700,
            backgroundColor: '#BED0F7',
            '&:hover': {
                backgroundColor: '#BED0F7',
            },
        },
        editButton: {
            marginLeft: theme.spacing(1.5),
        },
    });
});
var DeckSidebar = function (_a) {
    var classNameProp = _a.className, children = _a.children, deck = _a.deck, onClickEditCategories = _a.onClickEditCategories, onClickEditSubcategories = _a.onClickEditSubcategories, other = __rest(_a, ["className", "children", "deck", "onClickEditCategories", "onClickEditSubcategories"]);
    var classes = exports.useStyles();
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.root, classNameProp) }, other),
        children,
        react_1.default.createElement(core_1.List, null,
            react_1.default.createElement(core_1.ListSubheader, { disableSticky: true }, "Categories"),
            deck.categories.map(function (category) { return (react_1.default.createElement(core_1.ListItem, { button: true, key: category, className: clsx_1.default(deck.filterCategory === category && classes.filterActive), onClick: function () { return deck.toggleFilterCategory(category); } },
                react_1.default.createElement(core_1.ListItemText, null, category),
                react_1.default.createElement(core_1.ListItemSecondaryAction, null,
                    react_1.default.createElement(ProficiencyProgressCircle_1.default, { contrast: true, value: deck.categoryProficiency(category), size: 28 })))); }),
            react_1.default.createElement(Button_1.default, { variant: "text", color: "primary", size: "small", onClick: onClickEditCategories, className: classes.editButton }, "Edit categories")),
        react_1.default.createElement(core_1.List, null,
            react_1.default.createElement(core_1.ListSubheader, { disableSticky: true }, "Subcategories"),
            deck.subcategories.map(function (subcategory) { return (react_1.default.createElement(core_1.ListItem, { button: true, key: subcategory, className: clsx_1.default(deck.filterSubcategories.includes(subcategory) &&
                    classes.filterActive), onClick: function () { return deck.toggleFilterSubcategory(subcategory); } },
                react_1.default.createElement(core_1.ListItemText, null, subcategory),
                react_1.default.createElement(core_1.ListItemSecondaryAction, null,
                    react_1.default.createElement(ProficiencyProgressCircle_1.default, { contrast: true, value: deck.subcategoryProficiency(subcategory), size: 28 })))); }),
            react_1.default.createElement(Button_1.default, { variant: "text", color: "primary", size: "small", onClick: onClickEditSubcategories, className: classes.editButton }, "Edit subcategories"))));
};
exports.default = DeckSidebar;
//# sourceMappingURL=DeckSidebar.js.map